import _ from 'lodash';
import {
  call,
  put,
  select,
} from 'redux-saga/effects';
// import nsUtils from '@netsapiens/netsapiens-js/dist/utils';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsToken from '@netsapiens/netsapiens-js/dist/token';

import {
  selectMessages,
  selectSessions,
  setLoading,
  setMessagesList,
  setSessionsList,
} from '../../../state/chat/chatSlice';
import { selectCards, selectPinnedCards } from '../../../state/cards/cardsSlice';

import removeCard from '../../cardManagment/removeCard/removeCard';

export default function* endConversation({ payload }) {
  const debug = false;

  const { session } = payload;
  if (debug) console.debug('this is session to end: ', session);

  const decodedToken = nsToken.getDecoded();

  const res = yield nsApi.post({
    object: 'messagesession',
    action: 'end',
    domain: decodedToken.domain,
    user: decodedToken.user,
    session_id: `${session.id}`,
    term_queue: `${session.term_queue}`,
    send_end_message: 'yes',
  }, {
    object: 'messagesession',
    action: 'end',
    domain: decodedToken.domain,
    user: decodedToken.user,
    session_id: `${session.id}`,
    term_queue: `${session.term_queue}`,
    send_end_message: 'yes',
  });
  if (debug) console.debug('this is res end conversation: ', res);

  //
  // remove the session from sessions array.
  //
  const sessionsCurr = yield select(selectSessions);
  const updatedSessions = sessionsCurr.map((obj) => {
    if (obj.id === session.id) {
      return {
        ...obj,
        queue_status: 'complete',
      };
    }
    return obj;
  });

  yield put(setSessionsList(updatedSessions));

  //
  // remove any messages that are from the messages array.
  //
  const messages = yield select(selectMessages);
  const updatedMessages = _.filter(messages, (obj) => obj.id !== session.id);

  yield put(setMessagesList(updatedMessages));

  // ede12fb5faf583709be534624d4a1c26
  // remove the card from card list
  //
  const pinnedCards = yield select(selectPinnedCards);
  const otherCards = yield select(selectCards);

  const allCards = [...pinnedCards, ...otherCards];

  const cardToDelete = allCards.filter((obj) => (obj?.meta?.sessionId === session.id));
  yield call(removeCard, { payload: cardToDelete[0].id });

  yield put(setLoading(false));
  if (debug) console.debug('remove session');
}
